import { render } from "./Cashback.vue?vue&type=template&id=48eb951f&scoped=true"
import script from "./Cashback.vue?vue&type=script&lang=js"
export * from "./Cashback.vue?vue&type=script&lang=js"

import "./Cashback.vue?vue&type=style&index=0&id=48eb951f&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48eb951f"]])

export default __exports__